/**
 * Toast queue (U5). A tiny store so non-React code (the TanStack Query error
 * handler) can raise user-facing toasts; the ToastHost component drains it into
 * the Fluent Toaster. Wired to the API Error envelope: failed requests surface a
 * toast with the platform error message.
 */
import { create } from 'zustand';

export type ToastIntent = 'error' | 'warning' | 'success' | 'info';

export interface ToastItem {
  id: number;
  title: string;
  body?: string;
  intent: ToastIntent;
}

let nextId = 1;

export interface ToastState {
  toasts: ToastItem[];
  push: (toast: Omit<ToastItem, 'id'>) => number;
  remove: (id: number) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { ...toast, id }] }));
    return id;
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Convenience for the error path. */
export function toastError(title: string, body?: string): void {
  useToastStore.getState().push({ title, body, intent: 'error' });
}
